export default "__VITE_ASSET__B_EcLqv8__"